import styled from "styled-components";
import PropTypes from "prop-types";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { httpsCallable } from "firebase/functions";
import { fireDb, fireFunctions } from "../../../../Firebase/firebase";
import { doc, getDoc } from "firebase/firestore/lite";
import { setUser } from "../../../../Redux/userSlice";
import { TailSpin } from "react-loader-spinner";
import VoterCard from "./VoterCard/VoterCard";

const VoterSectionText = styled.div`
  color: rgba(0, 0, 0, 0.85);
  max-width: 480px;
`;

const MutedNote = styled.div`
  margin-top: 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
`;

const LoadingText = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`;

const VoterMatch = ({ candidates }) => {
  const dispatch = useDispatch();
  const userFull = useSelector((state) => state.user.value);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (voterId) => {
    setLoading(true);
    const linkVoterFn = httpsCallable(fireFunctions, "linkVoter");
    await linkVoterFn({ voterId, fsUserId: userFull.fsDocId });

    // after linking the voter, we need to fetch the new document from firestore that has this connection and dispatch the new user with the linked voter.
    const userDocRef = doc(fireDb, "unverifiedUsers", userFull.fsDocId);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      dispatch(
        setUser({
          fsDocId: userFull.fsDocId,
          ...userDoc.data(),
        }),
      );
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <LoadingWrapper>
        <TailSpin color="black" height={20} width={20} />
        <LoadingText>Linking your voter record...</LoadingText>
      </LoadingWrapper>
    );
  }

  return (
    <>
      <VoterSectionText>
        {candidates.length === 1
          ? "We found a potential match. Is this you?"
          : "We found potential matches. Select the correct one."}
      </VoterSectionText>
      {candidates.map((c) => (
        <VoterCard
          key={c.voterId}
          voterId={c.voterId}
          snapshot={c.snapshot}
          onConfirm={handleConfirm}
        />
      ))}
      <MutedNote>
        {candidates.length === 1 ? "Not you?" : "None of these you?"} Contact us
        by phone or email.
      </MutedNote>
    </>
  );
};

VoterMatch.propTypes = {
  candidates: PropTypes.arrayOf(PropTypes.object),
};

export default VoterMatch;
